import { SecretChatAccessRequestStatus } from 'APP/model/e2ee/e2eeModel.types';
import { DeviceStatus } from 'APP/model/userSettings/userSettingsModel.types';

import { GroupUserRole } from '../group/groupModel.types';
import { IMessage } from '../message/messageModel.types';

export interface IGroupCounterView {
  counter: number;
  groupId: string;
  lastEvent?: IGroupEvent;
  lastEventTs?: number;
  lastMessage?: IMessage;
  lastMessageTs?: number;
  lastUserMentionTs: number;
  opponentSeenTs?: number;
  previousEventTs?: number;
  previousMessageTs?: number;
  seenTs: number;
  totalMessagesCount?: number;
  unreadUserMentionsCounter: number;
  clearHistoryTs: number;
  updatedTs?: number;
}

export interface IGroupEventResponse {
  groupId: string;
  eventTs?: string;
  events: IGroupEvent[];
}

export interface IGroupEvent<T = object> {
  eventPayload?: T;
  groupId: string;
  id: string;
  ts: number;
  type: EventType;
}

export interface IGroupEventsRequestBatch {
  groupId: string;
  eventTs?: string;
}

export interface IGroupEventRequest {
  groupId: string;
  eventTs?: number;
  lastEventTs?: number;
}

export interface IGroupCounterState {
  groupId: string;
  updatedTs: string;
}

export enum EventType {
  ClearHistory = 'clear.history',
  ClearHistoryForAll = 'clear.history.for.all',
  ConfigGroupAds = 'config.group.ads',
  ConfigGroupPin = 'config.group.pin',
  ConfigGroupUnread = 'config.group.unread',
  DeleteMessagesFromUser = 'delete.messages.from.user',
  DraftWasUpdated = 'draft.was.updated',
  DraftInputWasUpdated = 'draft.input.was.updated',
  DraftsWereDeleted = 'drafts.were.deleted',
  Group = 'group',
  GroupChanged = 'group.changed',
  GroupSelfLeave = 'group.self.leave',
  GroupUserDisplayDataUpdated = 'group.user.display.data.updated',
  GroupWasDeleted = 'group.was.deleted',
  GroupParticipantsChanged = 'group.participants.changed',
  LinkPreviewWasCreated = 'link.preview.was.created',
  MessageReactionsWasUpdated = 'message.reactions.was.updated',
  MessageWasUpdated = 'message.was.updated',
  MessagesWereDeleted = 'messages.were.deleted',
  PermissionsWereChanged = 'permissions.were.changed',
  PhonebookWasUpdated = 'phonebook.was.updated',
  RolesWereChanged = 'roles.were.changed',
  ScheduledMessageWasUpdated = 'scheduled.message.was.updated',
  ScheduledMessagesWereDeleted = 'scheduled.messages.were.deleted',
  SpaceGroupVisibilityUpdated = 'space.group.visibility.updated',
  SpaceGroupsVisibilityUpdated = 'space.groups.visibility.updated',
  SpaceRolesWereChanged = 'space.roles.were.changed',
  SpaceSelfLeave = 'space.self.leave',
  SpaceUserWasBanned = 'space.user.was.banned',
  SpaceUserWasRemoved = 'space.user.was.removed',
  SpaceWasDeleted = 'space.was.deleted',
  SpacesPinChanged = 'spaces.pin.changed',
  StickerPackUpdated = 'sticker.pack.updated',
  UserBanStatusesWereChanged = 'user.ban.statuses.were.changed',
  UserBlockedMe = 'user.blocked.me',
  UserDisplayDataUpdated = 'user.display.data.updated',
  UserMarkedUnknownByMe = 'user.marked.unknown.by.me',
  UserPreferencesChanged = 'user.preferences.changed',
  UserPrivacySettingsUpdated = 'user.privacy.settings.updated',
  UserRewardUpdated = 'user.reward.updated',
  UserStickerPacksUpdated = 'user.sticker.packs.updated',
  UserUnblockedMe = 'user.unblocked.me',
  UserWasBanned = 'user.was.banned',
  UserWasBlockedByMe = 'user.was.blocked.by.me',
  UserWasRemoved = 'user.was.removed',
  UserWasUnblockedByMe = 'user.was.unblocked.by.me',
  SecretChatAccessRequestUpdate = 'secret.chat.access.request.update',
  ChatMessagesTtlChanged = 'chat.messages.ttl.changed',
}

export interface IDeleteMessagesEventPayloadResponse {
  groupId: string;
  messageIds: string[];
}

export interface IGroupEventPayloadResponse {
  groupId: string;
}

export interface IPinGroupEventPayloadResponse {
  groupIds: string[];
}

export interface IUpdateMessageEventPayloadResponse {
  messageGroup: string;
  messageId: string;
}

export interface IUpdateScheduledMessageEventPayloadResponse {
  groupId: string;
  messageId: string;
  status?: string;
}

export interface IDeleteScheduledMessageEventPayloadResponse {
  groupId: string;
  messageIds: string[];
}

export interface IUserStickerPacksUpdatedEventPayloadResponse {
  stickerPacks: string[];
}

export interface IChatMarkedAsUnreadEventPayloadResponse {
  groupId: string;
  unread: boolean;
}

export interface IChatMessagesTtlChangedPayloadResponse {
  ttlPeriodMs: number;
}

export interface IUserGroupRoleChanged {
  oldRole: GroupUserRole;
  newRole: GroupUserRole;
  groupId: string;
}

export interface IDeviceStatusUpdateEvent {
  userId: string;
  deviceId: string;
  status: DeviceStatus;
}

export interface ISecretChatAccessRequestUpdatePayloadResponse {
  userId: string;
  deviceId: string;
  status: SecretChatAccessRequestStatus;
  activeRequestsCount: number;
}
